// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterItem_wrapper__mcxEu","active":"FilterItem_active__9drG4"};